<!-- 顧客検索 -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin midlleform">
    <div class="errorform">
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" class="com_form_contet_admin midlleform">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">登録済み企業検索</h2>
      </div>
      <div>{{ initData.formText }}</div>
      <div style="margin-bottom: 30px">
        ※{{ initData.importDate }}時点のデータです。提案を実施される際は<br />
        &nbsp;&nbsp;&nbsp;
        <label class="required-mark"
          >提案先企業の管理者様へ提案可否を必ず確認</label
        >
        いただけますようお願いいたします。<br />
        <label class="required-mark">※</label
        >マークがある項目は必須項目です。<br />
        ※漢数字や「－」などは登録情報と異なる可能性があるため、<br />&nbsp;&nbsp;&nbsp;&nbsp;都道府県など必要最低限の内容に留めて入力ください
      </div>
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <table style="margin-left: -1px">
        <thead>
          <tr>
            <th style="width: 2%; text-align: right"></th>
            <th style="width: 17"></th>
            <th style="width: 63%"></th>
            <th style="width: 18%"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <label class="required-mark">※</label>
            </td>
            <td class="form-control-title">提案先企業名</td>
            <td>
              <input
                type="text"
                id="txtCustomerName"
                maxlength="255"
                class="form-control"
                v-model="inputData.customerName"
                ref="txtCustomerName"
                placeholder="全角で入力してください"
                style="height: 40px"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td class="form-control-title">都道府県</td>
            <td>
              <input
                type="text"
                maxlength="255"
                class="form-control"
                placeholder="全角で入力してください"
                style="margin-top: 7px; height: 40px"
                v-model="inputData.address1"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td class="form-control-title">
              住所続き
              <p style="font-size: 10px; margin-bottom: -3px">(市区町村など)</p>
            </td>
            <td>
              <input
                type="text"
                maxlength="255"
                class="form-control"
                v-model="inputData.address2"
                placeholder="全角で入力してください"
                style="margin-top: 7px; height: 40px"
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div class="form-inline flex-container">
        <div class="form-group"></div>
        <div class="form-group" style="margin-left: 255px">
          <button
            type="button"
            name="btnSerch"
            class="btn btn-footer btn-primary"
            @click="onSerch"
          >
            検索
          </button>
          <button
            type="button"
            name="btnClear"
            class="btn btn-footer btn-primary"
            @click="onClear"
          >
            クリア
          </button>
        </div>
      </div>
      <div class="inner1" style="margin-top: 30px">
        <h4>{{ serchResult }}</h4>
        <div v-if="serchResult">
          ※ウィズカウネット、べんりねっとの登録企業件数
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  isTokenAlive,
  sanitizeInput,
  hasNoGaiji,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface InputData {
  customerName: string; // 登録企業名
  address1: string; // 都道府県
  address2: string; // 住所続き
}
interface InitData {
  formText: string; // 説明文言
  importDate: string; // 企業データ取込日
}

export default defineComponent({
  name: "CustomerSerchComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const isLoading = ref(false);
    const serchResult = ref(""); // 検索結果
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const customerCount = ref(0);
    const txtCustomerName = ref<HTMLInputElement | null>(null);
    const inputData = ref<InputData>({
      customerName: "",
      address1: "",
      address2: "",
    });
    const initData = ref<InitData>({
      formText: "",
      importDate: "",
    });

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // 初期表示データ取得API
        const response = await apiAuthClient.post(
          "/api/CustomerSerch/getInitialDisplayData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        initData.value = data.resultModel;
        outputDebugLogs("initData.value.infoMsg:" + initData.value.formText);
        setTimeout(function () {
          // フォーカス設定
          if (txtCustomerName.value) {
            txtCustomerName.value.focus();
          }
        }, 1);

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";
        // 入力内容クリア
        inputData.value.customerName = "";
        inputData.value.address1 = "";
        inputData.value.address2 = "";

        // 検索結果クリア
        serchResult.value = "";

        setTimeout(function () {
          // フォーカス設定
          if (txtCustomerName.value) {
            txtCustomerName.value.focus();
          }
        }, 1);
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 検索ボタン押下
     */
    const onSerch = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック
        if (!validateInput()) {
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        isLoading.value = true;

        const sanitizedName = sanitizeInput(inputData.value.customerName);
        const sanitizedAddress1 = sanitizeInput(inputData.value.address1);
        const sanitizedAddress2 = sanitizeInput(inputData.value.address2);

        // 検索結果クリア
        serchResult.value = "";

        // 顧客検索API実行
        const response = await apiAuthClient.post(
          "/api/CustomerSerch/getCustomerCount",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            customerName: sanitizedName,
            address1: sanitizedAddress1,
            address2: sanitizedAddress2,
          }
        );

        const data = response.data;
        customerCount.value = data.customerCount;

        if (customerCount.value == 0) {
          errorMessage.value = formatMessage(messages.WRN_0003);
          return;
        }
        serchResult.value =
          "検索結果：" + customerCount.value.toLocaleString() + "件";
      } finally {
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 登録企業名
      const sanitizedName = sanitizeInput(inputData.value.customerName);
      // 必須チェック、使用不可文字チェック
      if (!sanitizedName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "登録企業名"));
      } else if (!hasNoGaiji(sanitizedName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "登録企業名"));
      }

      const sanitizedAddress1 = sanitizeInput(inputData.value.address1);
      if (!hasNoGaiji(sanitizedAddress1)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "都道府県"));
      }

      const sanitizedAddress2 = sanitizeInput(inputData.value.address2);
      if (!hasNoGaiji(sanitizedAddress2)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "住所続き"));
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      isLoading,
      inputData,
      serchResult,
      onClear,
      onSerch,
      txtCustomerName,
      initData,
    };
  },
});
</script>
<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.midlleform {
  width: 700px;
}
.flex-container {
  display: flex;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
</style>
